import VueRouter from 'vue-router'
import Login from './Login'
import Home from './Home'
import AuditRoute from './entries/Audit/route'
import CommissionRoute from './entries/Commission/route'
import SiteConfRoute from './entries/SiteConf/route'
import BlockInfoRoute from './entries/BlockInfo/route'
import BlockHeightTaskRoute from './entries/BlockHeightTask/route'
import GasRoute from './entries/Gas/route'
import AnnouncementRoute from './entries/Announcement/route'
import TicketRoute from './entries/Ticket/route'
import WalletRoute from './entries/Wallet/route'
import ReconciliationRoute from './entries/Reconciliation/route'
import UserOldRoute from './entries/UserOld/route'
import UserVerifyRoute from './entries/UserVerifyCode/route'
import OrderPlanRoute from './entries/OrderPlan/route'
import OrderLimitRoute from './entries/OrderLimit/route'
import SettingRoute from './entries/Setting/route'
import FinanceReportRoute from './entries/FinanceReport/route'
import LogsRoute from './entries/Logs/route'
import MyTokenRoute from './entries/MyToken/route'
import AppRoute from './entries/App/route'
import UserBillRoute from './entries/UserBill/route'
import TXRecordRoute from './entries/TXRecord/route'
import MessageRoute from './entries/Message/route'
import DashboardRoute from './entries/Dashboard/route'
import VoteRoute from './entries/Vote/route'
import FoundationRoute from './entries/Foundation/route'
import PledgeRoute from './entries/Pledge/route'
import AirDropRoute from './entries/NewAirdrop/route'
import TransferInnerRoute from './entries/TransferInner/route'
import VotingStrategyRoute from './entries/VotingStrategy/route'
import MiningRoute from './entries/Mining/route'
import QuizRoute from './entries/Quiz/route'
import NoticeRoute from './entries/Notice/route'
import DividendRoute from './entries/Dividend/route'
import PlatformQrcodeRoute from './entries/PlatformQrcode/route'
import PurchaseRoute from './entries/Purchase/route'
import RobotRoute from './entries/Robot/route'
import ReportRoute from './entries/Report/route'
import MsgChannelManageRoute from './entries/MsgChannelManage/route'
import MsgChannelSourceManageRoute from './entries/MsgChannelSourceManage/route'
import Bill from './entries/Bill/route'
import ApiLogRoute from './entries/ApiRequestLog/route'
import Statistics from './entries/Statistics/route'
import UserDividend from './entries/UserDividend/route'
import Star from './entries/Star/route'
import LeagueSetting from './entries/LeagueSetting/route'
import Kpi from './entries/Kpi/route'
import Cornucopia from './entries/Cornucopia/route'
import OrderTask from './entries/OrderTask/route'
import Lever from './entries/Lever/route'
import BalanceSearch from './entries/BalanceSearch/route'
import Abnormal from './entries/Abnormal/route'
import TimeOutRoute from './entries/TimeOut/route'
// import C2cRoute from './entries/C2C/route'
import OtherFun from './entries/OtherFun/route'
import UserControl from './entries/UserControl/route'
import OrderControl from './entries/OrderControl/route'
import CurrencyManagement from './entries/CurrencyManagement/route'
import Financial from './entries/Financial/route'
// import OTCRoute from './entries/OTC/route'
import FundsRoute from './entries/Funds/route'
import RebateListRoute from './entries/RebateList/route'
import RebateReviewRoute from './entries/RebateReview/route'
import PartnerListRoute from './entries/PartnerList/route'
// import PartnerRebatesRoute from './entries/PartnerRebates/route'
import GiftCoinRoute from './entries/GiftCoin/route'
import FriendRoute from './entries/Friend/route'
import MaintenanceRoute from './entries/Maintenance/route'
import ContractRoute from './entries/Contract/route'
import TigerRoute from './entries/Tiger/route'
// import OrderManegement from './entries/OederManegement/route'
import UserLoginRoute from './entries/UserLoginLog/route'
import UserOrderLogRoute from './entries/UserOrderLog/route'
import TransactionStatistics from './entries/TransactionStatistics/route'

// 租户
import MerchantCoin from './entries/MerchantCoin/route'
import CoinContract from './entries/CoinContract/route'
import SpotContract from './entries/SpotContract/route'
import TenantConfig from './entries/TenantConfig/route'
import TenantWalletConfig from './entries/TenantWalletConfig/route'
import SimulationRoute from './entries/Simulation/route'
import UserAddressRoute from './entries/Contract/UserAddress/route'
import TenantS3Admin from './entries/TenantS3Admin/route'
import TenantUserAdmin from './entries/TenantUserAdmin/route'
import TenantOss from './entries/TenantOss/route'
import TenantSpconfig from './entries/TenantSpconfig/route'
import TenantMenuManage from './entries/TenantMenuManage/route'
import TenantRoleManage from './entries/TenantRoleManage/route'
import RebateRiskRoute from './entries/RebateRisk/route'
import ActivityRoute from './entries/Activity/route'
import ActivityTaskRecordRoute from './entries/ActivityTaskRecord/route'
import ActivityLotteryRoute from './entries/ActivityLottery/route'
import SystemMenuManage from './entries/SystemMenuManage/route'
import SystemRoleManage from './entries/SystemRoleManage/route'
import SystemUserManage from './entries/SystemUserManage/route'

const routes = [
  { path: '/', component: Login },
  {
    path: '/home',
    component: Home,
    redirect: '/home/setting',
    children: [
      ActivityLotteryRoute,
      ActivityTaskRecordRoute,
      ActivityRoute,
      RebateRiskRoute,
      UserAddressRoute,
      // OTCRoute,
      AuditRoute,
      CommissionRoute,
      SiteConfRoute,
      BlockInfoRoute,
      BlockHeightTaskRoute,
      GasRoute,
      Financial,
      ...FundsRoute,
      RebateListRoute,
      RebateReviewRoute,
      PartnerListRoute,
      // PartnerRebatesRoute,
      GiftCoinRoute,
      FriendRoute,
      // AnnouncementRoute,
      // TicketRoute,
      // WalletRoute,
      // ReconciliationRoute,
      // OrderManegement,
      UserOldRoute,
      UserVerifyRoute,
      OrderPlanRoute,
      OrderLimitRoute,
      SettingRoute,
      FinanceReportRoute,
      // LogsRoute,
      // MyTokenRoute,
      AppRoute,
      // UserBillRoute,
      // TXRecordRoute,
      // MessageRoute,
      // DashboardRoute,
      // VoteRoute,
      FoundationRoute,
      // PledgeRoute,
      AirDropRoute,
      TransferInnerRoute,
      // VotingStrategyRoute,
      // MiningRoute,
      // QuizRoute,
      // NoticeRoute,
      // DividendRoute,
      // PlatformQrcodeRoute,
      // PurchaseRoute,
      RobotRoute,
      ReportRoute,
      MsgChannelManageRoute,
      MsgChannelSourceManageRoute,
      ContractRoute,
      TigerRoute,
      // Bill,
      // ApiLogRoute,
      // Statistics,
      // UserDividend,
      // Star,
      // LeagueSetting,
      // Kpi,
      Cornucopia,
      // OrderTask,
      // Lever,
      // BalanceSearch,
      // Abnormal,
      // TimeOutRoute,
      // C2cRoute,
      // OtherFun,
      // UserControl,
      // OrderControl,
      CurrencyManagement,
      MaintenanceRoute,
      UserLoginRoute,
      UserOrderLogRoute,
      TransactionStatistics,
      MerchantCoin,
      CoinContract,
      SpotContract,
      TenantConfig,
      TenantWalletConfig,
      SimulationRoute,
      TenantS3Admin,
      TenantUserAdmin,
      TenantMenuManage,
      TenantRoleManage,
      SystemMenuManage,
      SystemRoleManage,
      SystemUserManage,
      TenantOss,
      TenantSpconfig,
    ],
  },
]

export default new VueRouter({
  routes,
})
